import { responsiveTokenVars } from '@tundr/ds-tokens';
import { responsiveTokens } from '@tundr/ds-tokens/internal';

/**
 * Contract-based spacing variables resolved at runtime through the active theme.
 */
export const spacingVars = responsiveTokenVars.spacing;

/**
 * Literal spacing values from the DS token source.
 */
export const spacingScale = responsiveTokens.spacing;

export type SpacingToken = keyof typeof spacingScale;

export const getSpacing = (token: SpacingToken): string => spacingScale[token];
